import { LicenseInfo } from "@mui/x-license";

LicenseInfo.setLicenseKey(
  "16c81c4469dacaba5f2ed895da445f3bTz0xMTYwNzksRT0xNzg1NDU1OTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y"
);
